module.exports = __webpack_public_path__ + "img/step04_a_stand_power_left_front_leg - Copy.2cffbf11.png";